var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictureVerification"},[_c('slide-verify',{ref:"slideblock",attrs:{"w":420,"h":240,"slider-text":"向右拖动滑块填充拼图","accuracy":4,"imgs":_vm.imgs},on:{"again":_vm.onAgain,"success":_vm.onSuccess,"fail":_vm.onFail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }